import { withTheme } from '../config';
import { ButtonGroup, } from '@rneui/base/dist/ButtonGroup/ButtonGroup';
export { ButtonGroup };
export default withTheme(ButtonGroup, 'ButtonGroup');
